import { asyncAction } from '@jarvis.oddle/core/tools/redux/action'
import {
  getInvoiceMetaApi,
  getCheckoutPaymentMethodsApi as getInvoicePaymentMethodsApi,
  checkoutApi as payInvoiceApi
} from 'api/fesc/client'
import {
  previewModeGetCheckoutMetaApi as previewModeGetInvoiceApi,
  previewModeCheckoutApi as previewModePayInvoiceApi
} from 'api/fesc/previewModeClient'
import * as C from './constants'

export const fetchInvoiceMetaAction = asyncAction({
  getApi: (getState) => {
    const previewMode = getState()['@customisation'].data.previewMode
    return previewMode ? previewModeGetInvoiceApi : getInvoiceMetaApi
  },
  requestAction: C.GET_INVOICE_META_REQUEST,
  successAction: C.GET_INVOICE_META_SUCCESS,
  failureAction: C.GET_INVOICE_META_FAILURE
})

export const fetchInvoicePaymentMethodsAction = asyncAction({
  api: getInvoicePaymentMethodsApi,
  requestAction: C.GET_INVOICE_PAYMENT_METHODS_REQUEST,
  successAction: C.GET_INVOICE_PAYMENT_METHODS_SUCCESS,
  failureAction: C.GET_INVOICE_PAYMENT_METHODS_FAILURE
})

export const payInvoiceAction = asyncAction({
  getApi: (getState) => {
    const previewMode = getState()['@customisation'].data.previewMode
    return previewMode ? previewModePayInvoiceApi : payInvoiceApi
  },
  requestAction: C.PAY_INVOICE_REQUEST,
  successAction: C.PAY_INVOICE_SUCCESS,
  failureAction: C.PAY_INVOICE_FAILURE
})
